<template>
    <div>
        <home></home>
        <qesaco></qesaco>
        <envie></envie>
        <equipe></equipe>
        <contact-us></contact-us>
    </div>
</template>
<script>
import Home from './modules/Home'
import Qesaco from './modules/Qesaco'
import Envie from './modules/Envie'
import Equipe from './modules/Equipe'
import ContactUs from './modules/ContactUs'

export default {
  name: 'modules',
  components: {
    Home,
    Qesaco,
    Envie,
    Equipe,
    ContactUs,
  },
}
</script>